export const offersEN = {
    shippingTitle : "FREE SHIPPING",
    shippingText1 : "For orders more than ",
    shippingText2 : "€ free shipping!",
    cashTitle : "CASH ON DELIVERY",
    cashText : "Free of charge cash on delivery!" ,
    topSellers : "Top Sellers"  
}